import { lazy } from "react";
import {
  ROUTE_AUTO_LOGIN,
  ROUTE_AUTO_LOGIN_MAIN,
  ROUTE_DASHBOARD,
  ROUTE_STATICS,
  ROUTE_USERS,
  ROUTE_USER_INSPECTIONS,
} from "./routes";

// const MainPage = lazy(() => lazyRetry(() => import("../pages/mainPage")));
const MainPage = lazy(() => import("../pages/MainPage"));
const UsersPage = lazy(() => import("../pages/Users"));
const StaticsPage = lazy(() => import("../pages/Statics"));
const AutoLogin = lazy(() => import("../pages/AutoLogin"));
const UserInspections = lazy(() => import("../pages/UserInspections"));

export const siteRouting = [
  {
    path: [ROUTE_DASHBOARD],
    Page: MainPage,
    exact: false,
    props: {},
  },
  {
    path: [ROUTE_USERS],
    Page: UsersPage,
    exact: false,
    props: {},
  },
  {
    path: [ROUTE_STATICS],
    Page: StaticsPage,
    exact: false,
    props: {},
  },
  {
    path: [ROUTE_AUTO_LOGIN, ROUTE_AUTO_LOGIN_MAIN],
    Page: AutoLogin,
    exact: false,
    props: {},
  },
  {
    path: [ROUTE_USER_INSPECTIONS],
    Page: UserInspections,
    exact: false,
    props: {},
  },
];
